/**
 * Enmascarado de PII para respuestas, eventos y logs (arquitectura §6, eventos §1).
 * Nunca registres ni emitas documento, celular, cuenta o correo en claro.
 */
/** `1234567890` → `******7890`. */
export function maskTail(value, visible = 4, maskChar = '*') {
    const clean = value.trim();
    if (clean.length <= visible)
        return maskChar.repeat(clean.length);
    return maskChar.repeat(clean.length - visible) + clean.slice(-visible);
}
/** Documento de identidad: `CC 1020304050` → `******4050`. */
export function maskDocument(documentNumber) {
    return maskTail(documentNumber.replace(/\D/g, ''), 4);
}
/** Celular: `+573001234567` → `+57 ******4567`. */
export function maskPhone(phone) {
    const digits = phone.replace(/\D/g, '');
    const national = digits.startsWith('57') && digits.length === 12 ? digits.slice(2) : digits;
    const prefix = phone.trim().startsWith('+') ? '+57 ' : '';
    return prefix + maskTail(national, 4);
}
/** Cuenta: `00123456789` → `****6789`. */
export function maskAccount(accountNumber) {
    const digits = accountNumber.replace(/\s/g, '');
    return `****${digits.slice(-4)}`;
}
/** Correo: `maria.perez@correo.co` → `m***@correo.co`. */
export function maskEmail(email) {
    const [user = '', domain = ''] = email.split('@');
    if (!domain)
        return maskTail(email, 2);
    return `${user.charAt(0)}***@${domain}`;
}
/** Nombre: `María Pérez Gómez` → `María P. G.` (para eventos/logs operativos). */
export function maskName(fullName) {
    const [first = '', ...rest] = fullName.trim().split(/\s+/);
    return [first, ...rest.map((p) => `${p.charAt(0)}.`)].join(' ');
}
/** Valor de una llave Bre-B según su tipo. */
export function maskAlias(aliasType, aliasValue) {
    switch (aliasType) {
        case 'PHONE':
            return maskPhone(aliasValue);
        case 'DOCUMENT':
            return maskDocument(aliasValue);
        case 'EMAIL':
            return maskEmail(aliasValue);
        default:
            // Códigos de comercio y alfanuméricos son públicos por diseño.
            return aliasValue;
    }
}
//# sourceMappingURL=masking.js.map